module.exports = __webpack_public_path__ + "img/display spk 2.cb2b5a91.jpg";